import React from 'react';
import styled from 'styled-components';
import Carousel from 'react-bootstrap/Carousel';
import {wh, fontSize} from '../../mixins';


const StyledCarousel = styled(Carousel)`
    max-height: 40vh;
`;

const StyledItem = styled.div`
   ${wh('100%', 'auto')};
   margin: 0 auto;
   display: flex;
   flex-direction: column;
   align-items: center;
   min-height: 220px;
   color: #fff;
   
   b {
      ${fontSize(24)};
      line-height: 29px;
      margin: 10px 0 6px;
   }
   
   p {
      ${fontSize(14)};
      line-height: 19px;
      text-align: center;
      font-weight: 300;
      width: 210px;
      margin: 8px 0;
   }
`


const Slider = () => {

    const SLIDES = [
        {
            src: '../images/image1.png',
            title: 'Check Location',
            text: 'View live updates and history of family’s whereabouts'
        },
        {
            src: '../images/image2.png',
            title: 'Includes All Members',
            text: 'Share Premium with every family member'
        },
        {
            src: '../images/image4.png',
            title: 'Places',
            text: 'Get notified when family leaves or arrives'
        },
        {
            src: '../images/image5.png',
            title: 'Schedule Alerts',
            text: 'Notify you when something goes unplanned'
        },
    ];

    const renderSlide = (i) => (
        <Carousel.Item key={i.title}>
            <StyledItem>
                <img src={i.src} width='68' height='68' alt={i.title}/>
                <b>{i.title}</b>
                <p>{i.text}</p>
            </StyledItem>
        </Carousel.Item>
    );



    return (
        <StyledCarousel controls={false}>
            {SLIDES.map(renderSlide)}
        </StyledCarousel>
    );
};


export default Slider;
